/** plain-Thai wording of rules and conditions, shared by the rule list, the rule editor and the mapping board */
import { OP_LABEL, OPS_NO_VALUE } from "./constants";

/** rule names are authored as "[tag] condition → outcome"; the condition half is the problem title */
export const ruleTitle = (r) => String((r && r.name_th) || "").replace(/^\s*\[[^\]]*\]\s*/, "").split("→")[0].trim() || (r && r.name_th) || "";

export const ruleConditions = (r) => [...((r && r.if && r.if.all) || []), ...((r && r.if && r.if.any) || [])];

/** "สภาพบ้าน เป็นหนึ่งใน ชำรุด / ทรุดโทรม" — `qByCode` maps question code -> picker row from GET /questions */
export function condText(c, qByCode = {}) {
  const q = qByCode[c.question];
  const label = q ? q.desc : c.question || "(ยังไม่เลือกคำถาม)";
  // coded answers read better as "ตอบว่า …" than "เท่ากับ / เป็นหนึ่งใน …"
  const coded = q && (q.choices || []).length > 0;
  const op = (coded && { eq: "ตอบว่า", in: "ตอบว่า", ne: "ไม่ได้ตอบว่า", not_in: "ไม่ได้ตอบว่า", contains: "เลือก" }[c.op]) || OP_LABEL[c.op] || c.op;
  if (OPS_NO_VALUE.includes(c.op)) return `${label} ${op}`;
  const vals = Array.isArray(c.value) ? c.value : [c.value];
  const text = vals.map((v) => {
    const ch = q && (q.choices || []).find((x) => x.code === v);
    return ch ? ch.desc : v === true ? "ใช่" : v === false ? "ไม่ใช่" : v;
  }).filter((v) => v !== "" && v !== undefined && v !== null).join(coded ? " หรือ " : " / ");
  return `${label} ${op} ${text || "…"}`;
}

/** one sentence for the whole `if`: "A และ B และ (C หรือ D)" */
export function conditionSentence(rule, qByCode = {}) {
  const all = ((rule && rule.if && rule.if.all) || []).map((c) => condText(c, qByCode));
  const any = ((rule && rule.if && rule.if.any) || []).map((c) => condText(c, qByCode));
  const anyText = any.length > 1 && all.length ? `(${any.join(" หรือ ")})` : any.join(" หรือ ");
  return [...all, anyText].filter(Boolean).join(" และ ");
}
